import 'pixi';
import 'p2';
import 'phaser';

import init from 'states/init'
import load from 'states/load'
import menu from 'states/menu'
import play from 'states/play'
import win from 'states/win'

window.game = new Phaser.Game(1024, 768, Phaser.AUTO, 'canvas', null);
game.preserveDrawingBuffer = true;
game.antialias = false;

game.state.add('init', init);
game.state.add('load', load);
game.state.add('menu', menu);
game.state.add('play', play);
game.state.add('win', win);

game.state.start('init');

game.makeSharped = function makeSharped() {

    // https://belen-albeza.github.io/retro-canvas/phaser.html
    // scale the game 4x
    game.scale.scaleMode = Phaser.ScaleManager.USER_SCALE;
    game.scale.setUserScale(4, 4);

    // enable crisp rendering
    game.renderer.renderSession.roundPixels = true;
    Phaser.Canvas.setImageRenderingCrisp(game.canvas);

};

Phaser.BitmapText.prototype.updateText = function () {

    var data = this._data.font;

    if (!data)
    {
        return;
    }

    var text = this.text;
    var scale = this._fontSize / data.size;
    var lines = [];

    var y = 0;

    var addChar = this.separatorCode ? false : true;
    this.textWidth = 0;

    do
    {
        var line = this.scanLine(data, scale, text);

        line.y = y;

        lines.push(line);

        if (line.width > this.textWidth)
        {
            this.textWidth = line.width;
        }

        y += (data.lineHeight * scale);

        text = text.substr(line.text.length + 1);

    } while (line.end === false);

    this.textHeight = y;

    var t = 0;
    var align = 0;
    var ax = this.textWidth * this.anchor.x;
    var ay = this.textHeight * this.anchor.y;

    for (var i = 0; i < lines.length; i++)
    {
        var line = lines[i];

        if (this._align === 'right')
        {
            align = this.textWidth - line.width;
        }
        else if (this._align === 'center')
        {
            align = (this.textWidth - line.width) / 2;
        }

        for (var c = 0; c < line.text.length; c++)
        {
            var charCode = line.text.charCodeAt(c);
            var charData = data.chars[charCode];

            if (charData === undefined)
            {
                charCode = 32;
                charData = data.chars[charCode];
            }

            if (this.separatorCode && charCode === this.separatorCode) {
                addChar = !addChar;
                continue;   //just skip
            }
            if (addChar) {

                var g = this._glyphs[t];

                if (g) {
                    //  Sprite already exists in the glyphs pool, so we'll reuse it for this letter
                    g.texture = charData.texture;
                }
                else {
                    //  We need a new sprite as the pool is empty or exhausted
                    g = new PIXI.Sprite(charData.texture);
                    g.name = line.text[c];
                    this._glyphs.push(g);
                }

                g.position.x = (line.chars[c] + align) - ax;
                g.position.y = (line.y + (charData.yOffset * scale)) - ay;

                g.scale.set(scale);
                g.tint = this.tint;
                g.texture.requiresReTint = true;
                g.cachedTint = 0xFFFFFF;

                if (!g.parent) {
                    this.addChild(g);
                }
                t++;
            }
        }
    }

    //  Remove unnecessary children
    //  This moves them from the display list (children array) but retains them in the _glyphs pool
    for (i = t; i < this._glyphs.length; i++)
    {
        this.removeChild(this._glyphs[i]);
    }

};

Phaser.BitmapText.prototype.scanLine = function (data, scale, text) {

    var x = 0;
    var w = 0;
    var lastSpace = -1;
    var wrappedWidth = 0;
    var prevCharCode = null;
    var maxWidth = (this._maxWidth > 0) ? this._maxWidth : null;
    var chars = [];
    var charScale = 1;

    //  Let's scan the text and work out if any of the lines are > maxWidth
    for (var i = 0; i < text.length; i++)
    {
        var end = (i === text.length - 1) ? true : false;

        if (/(?:\r\n|\r|\n)/.test(text.charAt(i)))
        {
            return { width: w, text: text.substr(0, i), end: end, chars: chars };
        }
        else
        {
            var charCode = text.charCodeAt(i);
            var charData = data.chars[charCode];
            charScale = this.separatorCode && charCode === this.separatorCode ? 0 : 1;

            var c = 0;

            //  If the character data isn't found in the data array
            //  then we replace it with a blank space
            if (charData === undefined)
            {
                charCode = 32;
                charData = data.chars[charCode];
            }

            //  Adjust for kerning from previous character to this one
            var kerning = (prevCharCode && charData.kerning[prevCharCode]) ? charData.kerning[prevCharCode] : 0;

            //  Record the last space in the string and the current width
            if (/(\s)/.test(text.charAt(i)))
            {
                lastSpace = i;
                wrappedWidth = w;
            }

            //  What will the line width be if we add this character to it?
            c = (kerning + charData.texture.width + charData.xOffset) * scale * charScale;

            //  Do we need to line-wrap?
            if (maxWidth && ((w + c) >= maxWidth) && lastSpace > -1)
            {
                //  The last space was at "lastSpace" which was "i - lastSpace" characters ago
                return { width: wrappedWidth || w, text: text.substr(0, i - (i - lastSpace)), end: end, chars: chars };
            }
            else
            {
                w += (charData.xAdvance + kerning) * scale * charScale;

                chars.push(x + (charData.xOffset + kerning) * scale * charScale);

                x += (charData.xAdvance + kerning) * scale * charScale;

                prevCharCode = charCode;
            }
        }
    }

    return { width: w, text: text, end: end, chars: chars };

};


// WEBPACK FOOTER //
// ./src/index.js